import React, { useEffect, useRef, useState } from "react";
import { getCookie } from "../Utils";
import { useNavigate } from "react-router-dom";
import { eventInformation } from "./../api.js";
import "./../App.css";
import { Button } from "react-bootstrap";
import logo from "./logo.png";
import ValidationQR from "../Components/ValidationQr";
import ValidationNumber from "../Components/ValidationNumber";
import ToastComp from "../Components/Toast";
import InfoEvent from "../Components/InfoEvent";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

function Validation() {
  const navigate = useNavigate();
  const sliderRef = useRef(null);

  const [events, setEvents] = useState(null);
  const [messageTitle, setMessageTitle] = useState("");
  const [userName, setUserName] = useState("");
  const [message, setMessage] = useState("");
  const [toast, setToast] = useState(false);
  const [eventSelected, setEventSelected] = useState(null);

  useEffect(() => {
    if (eventSelected && Array.isArray(events)) {
      const index = events.findIndex(
        (item) =>
          item.event.trim().toLowerCase() === eventSelected.trim().toLowerCase()
      );

      if (index !== -1 && sliderRef.current) {
        sliderRef.current.slickGoTo(index);
      }
    }
  }, [eventSelected, events]);

  const backToLogin = () => {
    deleteCookie("eventHash");
    return navigate("/");
  };

  useEffect(() => {
    const hash = getCookie("eventHash");
    if (!hash) {
      return navigate("/");
    }
    const getEventData = async () => {
      const data = await eventInformation(hash);
      console.log("data:", data.length);
      setEvents(data);
    };

    getEventData();
  }, []);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    console.log("events:", events);
  }, [events]);

  return (
    <div className="App d-flex flex-column">
      <div className="header">
        <img
          src={logo}
          style={{ width: "auto", height: "auto", maxWidth: "170px" }}
          className="App-logo"
          alt="logo"
        />
        <Button variant="link" onClick={() => backToLogin()}>
          Salir
        </Button>
      </div>

      <ToastComp
        messageTitle={messageTitle}
        message={message}
        toast={toast}
        userName={userName}
      />

      <ValidationQR
        setEvent={setEvents}
        setMessageTitle={setMessageTitle}
        setMessage={setMessage}
        setToast={setToast}
        setUserName={setUserName}
        setEventSelected={setEventSelected}
      />

      <ValidationNumber
        setEvent={setEvents}
        setMessageTitle={setMessageTitle}
        setMessage={setMessage}
        setToast={setToast}
        setUserName={setUserName}
        setEventSelected={setEventSelected}
      />
      {Array.isArray(events) && events.length > 1 ? (
        <div
          className="slider-container"
          style={{
            width: "80%",
            margin: "10px auto",
          }}
        >
          <Slider ref={sliderRef} {...settings}>
            {events.map((item, index) => (
              <div key={index}>
                <InfoEvent
                  title={item.event}
                  ticketsValidated={item.ticketsValidated}
                  ticketsSold={item.ticketsSold}
                />
              </div>
            ))}
          </Slider>
        </div>
      ) : (
        events &&
        events.length > 0 && (
          <div
            className="slider-container"
            style={{
              width: "95%",
              margin: "20px auto",
            }}
          >
            {" "}
            <InfoEvent
              title={events[0].event}
              ticketsValidated={events[0].ticketsValidated}
              ticketsSold={events[0].ticketsSold}
            />
          </div>
        )
      )}
    </div>
  );
}

export default Validation;
